import { render, staticRenderFns } from "./index.vue?vue&type=template&id=15bf1fae&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=15bf1fae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bf1fae",
  null
  
)

export default component.exports